import withDirectionDetail from "../withDirectionDetail";
import DirectionVirusForm from "./DirectionVirusForm";
import DirectionVirusPDFGenerator from "./DirectionVirusPDFGenerator";

const directionFormKazakhName = 'Вирусологиялық зерттеуге жіберу ЖОЛДАМАСЫ'
const directionFormName = 'НАПРАВЛЕНИЕ на вирусологические исследование'
const directionFormNumber = '013'
const directionName = 'DirectionVirus'

export default withDirectionDetail(DirectionVirusForm, DirectionVirusPDFGenerator, directionFormKazakhName,  directionFormName,  directionFormNumber, directionName)